import { z } from 'zod';
export const EntityStatusSchema = z.enum([
    'draft',
    'active',
    'inactive',
    'testing',
    'archived',
    'deprecated',
]);
export const SignalStatusSchema = z.enum(['active', 'inactive', 'deprecated']);
export const CurrencyCodeSchema = z.enum([
    'USD',
    'EUR',
    'GBP',
    'JPY',
    'AUD',
    'CAD',
    'CHF',
    'CNY',
    'INR',
]);
export const BillingPeriodSchema = z.enum([
    'daily',
    'weekly',
    'monthly',
    'quarterly',
    'semi_annual',
    'annual',
]);
export const PricingModelSchema = z.enum([
    'flat',
    'tiered',
    'volume',
    'package',
    'usage_based',
    'hybrid',
]);
export const SignalTypeSchema = z.enum(['billable', 'cost']);
export const AggregationTypeSchema = z.enum([
    'count',
    'sum',
    'max',
    'unique_count',
    'average',
    'min',
]);
export const ActionTypeSchema = z.enum(['task', 'workflow', 'outcome']);
export const AGGREGATION_TYPES = AggregationTypeSchema.options;
export const ACTION_TYPES = ActionTypeSchema.options;
export const CostCategorySchema = z.enum([
    'infrastructure',
    'api',
    'compute',
    'storage',
    'bandwidth',
    'llm',
    'third_party',
    'licensing',
    'other',
]);
export const FeatureTypeSchema = z.enum(['metered', 'boolean']);
export const PlanFeatureTypeSchema = z.enum(['usage', 'included']);
export const PlanCategorySchema = z.enum(['plan', 'addon']);
export const PlanTypeSchema = z.enum([
    'standard',
    'enterprise',
    'trial',
    'freemium',
    'usage_based',
    'hybrid',
]);
export const ChargeTypeSchema = z.enum([
    'recurring',
    'one_time',
    'usage_based',
    'seat_based',
]);
export const TargetAudienceSchema = z.enum(['human', 'agent', 'both']);
export const InvoiceStatusSchema = z.enum([
    'draft',
    'pending_approval',
    'approved',
    'sent',
    'viewed',
    'void',
    'uncollectible',
    'disputed',
]);
export const InvoicePaymentStatusSchema = z.enum([
    'unpaid',
    'partially_paid',
    'paid',
    'refunded',
    'overdue',
]);
export const InvoiceLineItemSourceTypeSchema = z.enum([
    'charge',
    'agent_action',
    'feature',
    'addon',
    'manual',
]);
export const InvoiceGenerationStatusSchema = z.enum([
    'queued',
    'processing',
    'completed',
    'failed',
    'skipped',
]);
export const PaymentMethodSchema = z.enum([
    'credit_card',
    'debit_card',
    'bank_transfer',
    'ach',
    'wire',
    'check',
    'cash',
    'crypto',
    'wallet',
    'other',
]);
export const TransactionTypeSchema = z.enum([
    'charge',
    'refund',
    'credit',
    'debit',
    'adjustment',
    'write_off',
]);
export const ContractStatusSchema = z.enum([
    'draft',
    'pending_signature',
    'active',
    'suspended',
    'expired',
    'terminated',
    'renewed',
]);
export const ContractTypeSchema = z.enum([
    'standard',
    'custom',
    'enterprise',
    'trial',
    'pilot',
]);
export const BillingIntervalSchema = z.enum([
    'daily',
    'weekly',
    'monthly',
    'quarterly',
    'semi_annual',
    'annual',
]);
export const CollectionMethodSchema = z.enum([
    'charge_automatically',
    'send_invoice',
]);
export const ChangeTypeSchema = z.enum([
    'status_change',
    'price_adjustment',
    'term_change',
    'billing_change',
    'metadata_change',
]);
export const CancellationCategorySchema = z.enum([
    'customer_request',
    'non_payment',
    'policy_violation',
    'upgrade',
    'downgrade',
    'other',
]);
export const JurisdictionLevelSchema = z.enum([
    'federal',
    'state',
    'county',
    'city',
    'local',
]);
export const WalletStatusSchema = z.enum(['active', 'suspended', 'closed']);
export const WalletTransactionTypeSchema = z.enum([
    'credit',
    'debit',
    'recharge',
    'refund',
    'adjustment',
    'transfer',
]);
export const WalletTransactionStatusSchema = z.enum([
    'pending',
    'processing',
    'settled',
    'completed',
    'failed',
    'voided',
    'reversed',
]);
export const CreditTypeSchema = z.enum([
    'free',
    'purchased',
    'promotional',
    'bonus',
]);
export const RecurringRuleTriggerTypeSchema = z.enum([
    'scheduled',
    'threshold',
    'manual',
]);
export const RecurringRuleStatusSchema = z.enum([
    'active',
    'paused',
    'disabled',
]);
export const IntervalUnitSchema = z.enum(['daily', 'weekly', 'monthly']);
export const UsageResetPeriodSchema = z.enum([
    'never',
    'hourly',
    'daily',
    'weekly',
    'monthly',
    'yearly',
]);
export const ThresholdTypeSchema = z.enum(['balance_below', 'credits_below']);
export const TopUpMethodSchema = z.enum(['fixed_amount', 'target_balance']);
export const ExecutionStatusSchema = z.enum([
    'pending',
    'success',
    'failed',
    'retrying',
]);
export const RestrictionTypeSchema = z.enum(['whitelist', 'blacklist', 'limit']);
export const RestrictionModeSchema = z.enum(['strict', 'flexible']);
export const AlertTypeSchema = z.enum([
    'low_balance',
    'high_usage',
    'limit_reached',
    'unusual_activity',
]);
export const CustomerTypeSchema = z.enum(['individual', 'company', 'agent']);
export const ProfileKindSchema = z.enum(['human', 'ai_agent', 'system']);
export const CustomerStatusSchema = z.enum([
    'active',
    'inactive',
    'suspended',
    'archived',
]);
export const OrganizationStatusSchema = z.enum([
    'active',
    'inactive',
    'suspended',
]);
export const OrganizationSizeSchema = z.enum([
    'startup',
    'small',
    'medium',
    'large',
    'enterprise',
]);
export const DrawerModeSchema = z.enum(['create', 'edit']);
export const RoundingModeSchema = z.enum(['up', 'down', 'nearest']);
export const EntitlementStepSchema = z.enum(['list', 'create', 'edit']);
export const PlanMenuSchema = z.enum(['pricing', 'entitlements']);
export const StringFilterOperatorSchema = z.enum([
    'is',
    'starts_with',
    'ends_with',
    'contains',
]);
export const WebhookEventTypeSchema = z.enum([
    'agent.created',
    'agent.updated',
    'agent.deleted',
    'agent.task_completed',
    'event.created',
    'invoice.created',
    'invoice.finalized',
    'invoice.paid',
    'payment.received',
    'payment.failed',
    'contract.created',
    'contract.cancelled',
    'customer.created',
    'customer.updated',
    'usage.threshold_exceeded',
    'billing.limit_reached',
]);
export const WebhookDeliveryStatusSchema = z.enum([
    'pending',
    'delivered',
    'failed',
    'cancelled',
]);
//# sourceMappingURL=enums.js.map